module.exports = __webpack_public_path__ + "static/lifting-58fa45c7b22a76de495e04237e95dadd.png";